import React, { useState } from "react";
import DatePicker from "react-datepicker";
import "./datePicker.css";

const DatePickerPopup = ({
  updateMaintenanceDate,
  onCancel,
  initialDate,
  disableBeforeDate,
  popupData,
}) => {
  const [selectedDate, setSelectedDate] = useState(
    initialDate ? new Date(initialDate) : new Date()
  );

  const minDate = disableBeforeDate ? new Date(disableBeforeDate) : new Date();

  const isDateDisabled = (date) => {
    return date < minDate;
  };

  return (
    <div className="date-picker-overlay" onClick={onCancel}>
      <div
        className="date-picker-container"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="svg-box">{/* Your SVG icon */}</div>

        <div className="date-picker-header">
          <h3 className="date-picker-title">تغيير موعد صيانة الطلب</h3>
          <div className="date-picker-reqNumber">
            <h5>{popupData.RequestNumber}</h5>
          </div>
        </div>

        <p>
          سنرسل تفاصيل طلبك إلى المسؤول، وسنحدد لك موعدًا جديدًا يناسبك ونُعلمك
          به
        </p>

        <div className="date-picker-wrapper">
          <DatePicker
            selected={selectedDate}
            onChange={(date) => setSelectedDate(date)}
            inline
            locale="ar"
            minDate={minDate}
            calendarClassName="custom-calendar"
            dayClassName={(date) => {
              const isDisabled = isDateDisabled(date);
              return isDisabled ? "custom-day disabled-day" : "custom-day";
            }}
            renderCustomHeader={({
              monthDate,
              decreaseMonth,
              increaseMonth,
            }) => {
              const prevMonthDisabled =
                minDate &&
                monthDate.getMonth() <= minDate.getMonth() &&
                monthDate.getFullYear() <= minDate.getFullYear();

              return (
                <div className="custom-header">
                  <button
                    onClick={decreaseMonth}
                    className="nav-button"
                    disabled={prevMonthDisabled}
                  >
                    ‹
                  </button>
                  <span className="month-title">
                    {monthDate.toLocaleString("ar-EG", {
                      month: "long",
                      year: "numeric",
                    })}
                  </span>
                  <button onClick={increaseMonth} className="nav-button">
                    ›
                  </button>
                </div>
              );
            }}
          />
        </div>

        <div className="date-picker-actions">
          <button
            className="confirm-btn"
            onClick={() => {
              // Fix the timezone shifting bug by setting noon time
              const normalizedDate = new Date(
                selectedDate.getFullYear(),
                selectedDate.getMonth(),
                selectedDate.getDate(),
                12,
                0,
                0
              );
              updateMaintenanceDate(normalizedDate);
            }}
          >
            تأكيد الطلب
          </button>

          <button className="cancel-btn" onClick={onCancel}>
            عودة
          </button>
        </div>
      </div>
    </div>
  );
};

export default DatePickerPopup;
